import {Injectable} from '@angular/core';
import {TrackingMiddleware} from "../../../middlewares/tracking/tracking.middleware";
import {Config} from "../../config/config.service";

@Injectable()
export class WebLocationService {
    private geoId: string | null = null;
    private testUrl: string = 'https://www.colossusbets.com/env.config.js';

    constructor(private _trackingMiddleware: TrackingMiddleware, private config: Config) {
    }

    initLocation(): void {
        if (!this.config.CONFIG.hasGeoFence) {
            return;
        }
        this.fetchGeoId().then(res => {
            this.geoId = res;
            this._trackingMiddleware.setGeoId(this.geoId);
        })
    }

    async fetchGeoId(): Promise<string | null> {
        if (this.geoId) return this.geoId;

        return new Promise((resolve, reject) => {
            this.fetchGeoIdFromHttp(resolve, reject);
        })
    }

    private fetchGeoIdFromHttp(resolve: (value: string | null) => void, reject: () => void) {
      const oXmlHttp = new XMLHttpRequest();
      oXmlHttp.onreadystatechange = () => {
            if (oXmlHttp.readyState == XMLHttpRequest.DONE) {
                if (oXmlHttp.status == 200) {
                  const x = oXmlHttp.getResponseHeader('geoip_country_code');
                  this.geoId = x;
                    resolve(x);
                } else {
                    resolve(null);
                }
            }
        }
        oXmlHttp.open('get', this.testUrl);
        oXmlHttp.send();
    }
}
